import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'

///////////////////////////////////////////////////////////////////////////////

export const SubscriptionNotFound = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()

  return (
    <div className="subscription-not-found">
      <div className="header">
        <div className="title">
          <h2 className="text">
            {api.trans('blocks.subscription_not_found.title')}
          </h2>
        </div>
      </div>
      <div
        className="main"
        dangerouslySetInnerHTML={{
          __html: api.trans('blocks.subscription_not_found.text_html'),
        }}
      />
    </div>
  )
})
